import peopleFill from '@iconify/icons-eva/people-fill';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import { Icon } from '@iconify/react';
import ReportIcon from '@mui/icons-material/Report';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import GavelIcon from '@mui/icons-material/Gavel';
import PolicyIcon from '@mui/icons-material/Policy';
import GroupIcon from '@mui/icons-material/Group';
import HandshakeIcon from '@mui/icons-material/Handshake';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import LoginIcon from '@mui/icons-material/Login';
import RecommendIcon from '@mui/icons-material/Recommend';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import SnowboardingIcon from '@mui/icons-material/Snowboarding';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { AiFillBank } from 'react-icons/ai';
import { GiJourney, GiPayMoney, GiProfit, GiReceiveMoney, GiTakeMyMoney } from 'react-icons/gi';
import { IoIosPeople } from 'react-icons/io';
import DatasetIcon from '@mui/icons-material/Dataset';

// import { IoNewspaperSharp } from 'react-icons/io';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: getIcon(pieChart2Fill),
    pageCode: 'DASHBOARD_PAGE'
  },
  {
    title: 'Accounting',
    path: '/accounting',
    icon: <AccountBalanceWalletIcon />,
    pageCode: 'ACCOUNTING_PAGE'
  },
  {
    title: 'Prospect',
    path: '/prospect',
    icon: <PermContactCalendarIcon />,
    pageCode: 'PROSPECT_PAGE'
  },
  {
    title: 'Data',
    path: '/data',
    icon: <DatasetIcon />,
    pageCode: 'DATA'
  },
  {
    title: 'Call center',
    path: '/call-center',
    icon: <SupportAgentIcon />,
    pageCode: 'CALL_CENTER_PAGE'
  },
  {
    title: 'Leads',
    path: '/leads',
    icon: getIcon(peopleFill),
    pageCode: 'LEADS_PAGE'
  },
  {
    title: 'Recommendation',
    path: '/recommendation',
    icon: <RecommendIcon />,
    pageCode: 'RECOMMENDATION_PAGE'
  },
  {
    title: 'Log In',
    path: '/login',
    icon: <LoginIcon />,
    pageCode: 'LOG_IN_PAGE'
  },
  {
    title: 'Bankops',
    path: '/bankops',
    icon: <AiFillBank fontSize="1.5rem" />,
    pageCode: 'BANKOPS_PAGE'
  },
  {
    title: 'Disburse',
    path: '/disburse',
    icon: <PriceCheckIcon />,
    pageCode: 'DISBURSE_PAGE'
  },
  {
    title: 'Rejected',
    path: '/rejected',
    icon: <ThumbDownAltIcon />,
    pageCode: 'REJECTED_PAGE'
  },
  {
    title: 'Revenue',
    path: '/revenue',
    icon: <GiTakeMyMoney fontSize="1.5rem" />,
    pageCode: 'REVENUE_PAGE'
  },
  {
    title: 'Payout',
    path: '/payout',
    icon: <GiPayMoney fontSize="1.5rem" />,
    pageCode: 'PAYOUT_PAGE'
  },
  {
    title: 'Sales',
    path: '/sales',
    icon: <GiProfit fontSize="1.5rem" />,
    pageCode: 'SALES_PAGE'
  },
  {
    title: 'Receivable',
    path: '/receivable',
    icon: <GiReceiveMoney fontSize="1.5rem" />,
    pageCode: 'RECEIVABLE_PAGE'
  },
  {
    title: 'Payable',
    path: '/payable',
    icon: <CurrencyRupeeIcon />,
    pageCode: 'PAYABLE_PAGE'
  },
  {
    title: 'Report',
    path: '/report',
    icon: <ReportIcon />,
    pageCode: 'REPORT_PAGE'
  },
  {
    title: 'Bankops',
    path: '/bankops',
    icon: <AiFillBank fontSize="1.5rem" />,
    pageCode: 'BANKOPS_PAGE'
  },
  {
    title: 'Disburse',
    path: '/disburse',
    icon: <PriceCheckIcon />,
    pageCode: 'DISBURSE_PAGE'
  },
  {
    title: 'Rejected',
    path: '/rejected',
    icon: <ThumbDownAltIcon />,
    pageCode: 'REJECTED_PAGE'
  },
  {
    title: 'On Boarding',
    path: '/onboarding',
    icon: <SnowboardingIcon />,
    pageCode: 'ONBOARDING_PAGE'
  },
  {
    title: 'Agreement',
    path: '/agreement',
    icon: <GavelIcon />,
    pageCode: 'AGREEMENT_PAGE'
  },
  {
    title: 'Policy',
    path: '/policy',
    icon: <PolicyIcon />,
    pageCode: 'POLICY_PAGE'
  },
  {
    title: 'Partners',
    path: '/partners',
    icon: <HandshakeIcon />,
    pageCode: 'PARTNER_PAGE'
  },
  {
    title: 'Customer',
    path: '/customer',
    icon: <IoIosPeople fontSize="1.5rem" />,
    pageCode: 'CUSTOMER_PAGE'
  },
  {
    title: 'Journey',
    path: '/journey',
    icon: <GiJourney fontSize="1.5rem" />,
    pageCode: 'JOURNEY_PAGE'
  },
  // {
  //   title: 'Admin',
  //   path: '/admin',
  //   icon: getIcon(peopleFill)
  // }
  {
    title: 'Integration',
    path: '/integration',
    icon: <IntegrationInstructionsIcon />,
    pageCode: 'INTEGRATION_PAGE'
  },
  {
    title: 'Master',
    path: '/master',
    icon: <DomainVerificationIcon />,
    pageCode: 'MASTER_PAGE'
  },
  {
    title: 'Users',
    path: '/users',
    icon: <GroupIcon />,
    pageCode: 'USER_PAGE'
  },
  {
    title: 'Accounting',
    path: '/accounting',
    icon: <GroupIcon />,
    pageCode: 'USER_PAGE'
  }
];

export default sidebarConfig;
